import React from 'react';
import copy from 'copy-to-clipboard';
import config from '@/config';
import Button from '@/shared/components/Button';
import { UrlIcon } from '@/shared/components/Icons';
import ToastrService from '@/shared/services/ToastrService';
import messages from './interactionMessages';

const copyLinkToInteraction = (interaction, intl) => {
  const url = `${config.appUrls.app}/#/interactions/${interaction.relationId}/${interaction.id}`;
  if (copy(url)) {
    ToastrService.success(intl.formatMessage(messages.ValueCopiedToClipboard));
  }
};
const CopyLinkToInteractionButton = ({ interaction, intl, ...others }) => (
  <Button
    {...others}
    title={intl.formatMessage(messages.CopyLinkToInteraction)}
    onClick={() => copyLinkToInteraction(interaction, intl)}
    showProgress
  >
    <UrlIcon />
  </Button>
);
export default CopyLinkToInteractionButton;
